import Intervention from "./intervention";

class Interventions {
    templates = {
        intervention: null,
    };

    interventions = [];

    total = {
        energy: 0,
        protein: 0,
    };

    constructor($el) {
        this.$el = $el;
        this.$add = this.$el.find('[data-interventions="add"]');
        this.$container = this.$el.find('[data-interventions="container"]');
        this.templates.intervention =
            document.querySelector("#tpl-intervention");
        this.index = 0;
        this.old = this.$el.data("old");
        this.errors = this.$el.data("errors");
        // this.old = JSON.parse(this.$el.data('old'));
        // console.log('old', this.old);

        this.init();
    }

    init = () => {
        this.$add.on("click", this.addClickHandler);

        if (this.old) {
            this.initOldInterventions();
        }

        if (this.errors) {
            this.showErrors();
        }
    };

    showErrors = () => {
        for (const [key, value] of Object.entries(this.errors)) {
            let selector = key
                .replace(".", "[")
                .replace(".", "]")
                .replace("protein", "[protein]")
                .replace("energy", "[energy]")
                .replace("frequency", "[frequency]")
                .replace("amount", "[amount]")
                .replace("liquid_meal_id", "[liquid_meal_id]");
            selector = `[name="${selector}"]`;

            const $field = $(selector);
            const $formGroup = $field.closest(".form-group");

            this.appendErrorMessage($formGroup, value[0]);
            // let parts = key.split('.');
            // let index = parts[1];
            // let field = parts[2];

            // console.log('index', index);
            // console.log('field', field);
        }
    };

    appendErrorMessage = ($target, text) => {
        $target.addClass("form-error");

        $target.append(`<div class="invalid-feedback">${text}</div>`);
    };

    initOldInterventions = () => {
        // this.old.forEach((intervention) => {
        //     console.log('intervention', intervention);

        //     this.addIntervention(intervention);
        // });

        for (const [key, value] of Object.entries(this.old)) {
            if (typeof value.intervention_type_id === "string") {
                value.intervention_type_id = JSON.parse(
                    value.intervention_type_id
                );
            }

            this.addIntervention(value);
        }

        this.calculateTotal();
    };

    addClickHandler = (e) => {
        e.preventDefault();
        this.addIntervention();
    };

    addIntervention = (oldValues = null) => {
        const index = this.index;
        let template = this.templates.intervention.cloneNode(true);

        // replace placeholder
        template.innerHTML = template.innerHTML.replaceAll(
            "%counter%",
            index + 1
        );
        template.innerHTML = template.innerHTML.replaceAll("%index%", index);

        // clone template
        const clone = document.importNode(template.content, true);
        this.$container.append(clone);

        const $intervention = $(
            `[data-intervention="el"][data-index="${index}"]`
        );

        // adjust slider height
        this.adjustSliderHeight();

        // push intervention
        this.interventions.push(
            new Intervention($intervention, index, this, oldValues)
        );
        this.index++;
    };

    deleteIntervention = (index) => {
        this.interventions = this.interventions.filter((el) => {
            return el.id != index;
        });
        const $intervention = this.$container.find(
            `[data-intervention="el"][data-index="${index}"]`
        );
        $intervention.remove();

        this.calculateTotal();
        // this.$container.find(`[data-intervention="el"][data-index="${index}"]`).remove();
    };

    adjustSliderHeight = () => {
        const sliderHeight = $('div[data-slick-index="6"]').outerHeight(true);
        $(".slick-list").animate({ height: sliderHeight });
    };

    calculateTotal = () => {
        let energy = 0;
        let protein = 0;
        this.interventions.forEach((intervention) => {
            energy += intervention.values.energy;
            protein += intervention.values.protein;
        });

        this.total.energy = energy;
        this.total.protein = protein;

        this.$el.trigger("changed");
    };
}

export default Interventions;
